import { ANNOUNCEMENT } from "@/data/announcement";

export const AnnouncementBanner = () => {
  const { title, lines = [], caption, photos = [] } = ANNOUNCEMENT;
  if (!title?.trim()) return null;
  return (
    <div className="mx-auto max-w-5xl px-4 pb-8 sm:px-6 sm:pb-10" data-testid="announcement-banner">
      <div className="rounded-xl border border-cypress-gold bg-cypress-green/40 px-4 py-4 text-center shadow-[0_0_28px_rgba(201,162,39,0.25)] sm:px-6 sm:py-5">
        <p className="text-sm font-black uppercase tracking-[0.06em] text-cypress-gold sm:text-base sm:tracking-[0.12em]" data-testid="announcement-title">
          {title}
        </p>
        {lines.length > 0 && (
          <div className="mt-2 space-y-0.5 text-sm leading-relaxed text-cypress-cream/85 sm:text-base" data-testid="announcement-text">
            {lines.map((l) => (
              <p key={l}>{l}</p>
            ))}
          </div>
        )}
        {photos.length > 0 && (
          <div className={`mx-auto mt-3 grid gap-3 ${photos.length > 1 ? "grid-cols-2" : "max-w-[500px] grid-cols-1"}`} data-testid="announcement-photos">
            {photos.map((p, i) => (
              <img
                key={p.src}
                src={p.src}
                alt={p.alt}
                loading="lazy"
                className="h-auto w-full rounded-lg border border-cypress-gold/20"
                data-testid={`announcement-photo-${i + 1}`}
              />
            ))}
          </div>
        )}
        {caption && (
          <p className="mt-2 text-xs text-cypress-cream/70 sm:text-sm" data-testid="announcement-caption">
            {caption}
          </p>
        )}
      </div>
    </div>
  );
};
